import { MeterBarWebElementBase } from './MeterBarWebElementBase';

/**
 * The component WebElement for [oj-c-meter-bar](../../jsdocs/oj-c.MeterBar.html).
 * Do not instantiate this class directly, instead, use
 * [findMeterBar](../functions/findMeterBar.html).
 */
export class MeterBarWebElement extends MeterBarWebElementBase {
  // Put overrides here
}
